import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { CheckCircle, Email } from "@mui/icons-material";
import { Modal } from "components/common/Modal";
import { AssetRetrieval } from "types/assetRetrieval";

interface AssetRetrievalCancelSuccessModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  assetRetrieval: AssetRetrieval | null;
}

export function AssetRetrievalCancelSuccessModal({
  open,
  setOpen,
  assetRetrieval,
}: AssetRetrievalCancelSuccessModalProps) {
  if (!assetRetrieval) return null;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal open={open} setOpen={handleClose}>
      <Box>
        <Box sx={{ textAlign: "center" }}>
          <CheckCircle color="success" sx={{ fontSize: "60px" }} />
          <Typography mt={1} variant="h5" component="h2" fontWeight={800}>
            Order cancelled successfully!
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              mt: 2,
              p: 2,
              backgroundColor: "#f0f8ff",
              borderRadius: 1,
              border: "1px solid #e3f2fd",
            }}
          >
            <Email color="primary" />
            <Typography variant="body1">We emailed your employee about the cancellation.</Typography>
          </Box>

          <Typography mt={2} variant="body1">
            Order number: {assetRetrieval.orderNumber}
          </Typography>

          <Box mt={3}>
            <Button variant="contained" onClick={handleClose} size="large">
              OK
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
